import { isNullOrWhitespace } from "./isNullOrWhitespace";

export function notNullOrWhitespace(input?: string | null): boolean {
  return !isNullOrWhitespace(input);
}
